import { z } from 'zod';

/**
 * Mark production complete form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markProductionCompleteFormSchema)
 */
const markProductionCompleteFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm production is complete',
    }),
});
/**
 * Finalize deal in inventory system form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(finalizeDealInInventorySystemFormSchema)
 */
const finalizeDealInInventorySystemFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm deal has been finalized in inventory system',
    }),
});

export { finalizeDealInInventorySystemFormSchema, markProductionCompleteFormSchema };
//# sourceMappingURL=productionValidation.js.map
